import { myAxios } from "./axios";

export function getStatusLeadContacts(payload, { page, limit }) {
  let config = {
    params: {
      page,
      limit,
      ...(payload || {}),
    },
  };
  return myAxios.get("/statusLeadContact", config);
}

export function getStatusLeadContact(id) {
  return myAxios.get("/statusLeadContact/" + id);
}

export function addStatusLeadContact(data) {
  return myAxios.post("/statusLeadContact", data);
}

export function editStatusLeadContact(id, data) {
  return myAxios.put("/statusLeadContact/edit/" + id, data);
}

export function deleteStatusLeadContact(id) {
  return myAxios.delete("/statusLeadContact/" + id);
}
